var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiltericon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10193",
    "data-name": "Rectangle 10193",
    width: 29.855,
    height: 31.938,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8029",
    "data-name": "Group 8029",
    transform: "translate(-1746 -111)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2076",
    "data-name": "Ellipse 2076",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(1746 111)",
    fill: "#734bd1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8028",
    "data-name": "Group 8028",
    transform: "translate(1755.072 123.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53685",
    "data-name": "Path 53685",
    d: "M0,14.092,11.677,25.667V39.412l6.388-4.16V25.667L29.4,14.092Z",
    transform: "translate(0 -7.474)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8027",
    "data-name": "Group 8027",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8026",
    "data-name": "Group 8026",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53686",
    "data-name": "Path 53686",
    d: "M28.29,0H1.565A1.565,1.565,0,0,0,0,1.565V5.351H29.855V1.565A1.565,1.565,0,0,0,28.29,0",
    transform: "translate(0 0)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltericon);
export default __webpack_public_path__ + "static/media/filtericon.7a5e47cbacf3ef46bc798cc00b49476f.svg";
export { ForwardRef as ReactComponent };